<div class="upload-projections">

  @if (status() === 'idle' || status() === 'parsing') {
    <tidy-text [body]="('Upload a TIDY income estimate PDF to populate the next 12 months of projected P&amp;L for ' | translate) + data.addressLabel + '.'" />

    <div
      class="upload-target"
      [class.drag-over]="isDragOver()"
      (click)="selectFile()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <tidy-image [src]="'assets/svg/cloud-upload-outline.svg'" class="upload-icon" />
      <tidy-text [helper]="'Drag & drop a PDF here, or use the button below. We read the annual figures and spread them across the year using short-term-rental seasonality.'" />
    </div>

    <tidy-button
      [text]="'Upload PDF'"
      [image]="'assets/svg/document-attach-outline.svg'"
      [action]="selectFileAction"
      class="primary" />

    <div class="example-toggle" (click)="toggleExample()">
      <tidy-text
        [actionBody]="showExample() ? 'Hide example' : 'What should the PDF look like?'"
        class="link" />
    </div>

    @if (showExample()) {
      <div class="example">
        <div class="example-caption">A TIDY income estimate — we read the annual figures</div>
        <div class="example-doc">
          <div class="example-doc-row">
            <span>Annual gross revenue</span><span class="pos">$65,177</span>
          </div>
          <div class="example-doc-row"><span>Airbnb host fee</span><span>−$10,102</span></div>
          <div class="example-doc-row"><span>TIDY fee</span><span>−$2,148</span></div>
          <div class="example-doc-row muted"><span>Utilities, insurance, …</span><span></span></div>
          <div class="example-doc-row total">
            <span>Net (annual)</span><span class="pos">$47,027</span>
          </div>
        </div>

        <tidy-image [src]="'assets/svg/arrow-down-outline.svg'" class="example-arrow" />

        <div class="example-caption">…and spread them across 12 months of Projected P&amp;L</div>
        <div class="example-months">
          @for (m of exampleMonths; track m.label) {
            <div class="example-month">
              <div class="example-bar-track">
                <div class="example-bar" [style.height.%]="m.pct"></div>
              </div>
              <span class="example-month-label">{{ m.label }}</span>
            </div>
          }
        </div>
        <div class="example-note">
          Revenue and %-based fees follow short-term-rental seasonality (summer peak);
          fixed reserves are split evenly. Cells you've already edited are never overwritten.
        </div>
      </div>
    }
  }

  @if (status() === 'preview' || status() === 'applying') {
    @if (preview(); as p) {
      <tidy-text [body]="'Found this estimate. Review, then apply.'" />

      <div class="preview-card">
        <div class="preview-row total">
          <span class="preview-label">Annual gross revenue</span>
          <span class="preview-value positive">{{ p.gross }}</span>
        </div>
        @for (e of p.expenses; track e.id) {
          <div class="preview-row">
            <span class="preview-label">{{ e.label }}</span>
            <span class="preview-value">{{ e.amount }}</span>
          </div>
        }
        <div class="preview-row noi">
          <span class="preview-label">Net operating income</span>
          <span class="preview-value positive">{{ p.noi }}</span>
        </div>
      </div>

      @if (!p.reconciles) {
        <div class="reconcile-warning">
          ⚠️ These figures don't add up to the PDF's stated net{{ p.statedNoi ? ' (' + p.statedNoi + ')' : '' }}.
          This may be a different report format than a standard TIDY income estimate — review carefully before applying.
        </div>
      }

      <div class="apply-note">
        Fills <strong>empty</strong> Projected cells for {{ data.addressLabel }} from
        <strong>{{ windowLabel() }}</strong>. Existing manual edits are kept.
      </div>

      <tidy-button
        [text]="'Apply projections'"
        [action]="applyAction"
        class="primary" />

      <div class="secondary-link" (click)="reset()">
        <tidy-text [actionBody]="'Choose a different file'" class="link" />
      </div>
    }
  }

  @if (status() === 'done') {
    @if (outcome(); as o) {
      <div class="result" [class.is-success]="o.kind === 'success'">
        <tidy-image [src]="o.icon" class="result-icon" />
        <tidy-text [title]="o.title" class="result-title" />
        <tidy-text [body]="o.detail" class="result-detail" />

        <tidy-button
          [text]="'Done'"
          [action]="closeAction"
          class="primary" />

        @if (o.kind !== 'success') {
          <div class="secondary-link" (click)="reset()">
            <tidy-text [actionBody]="'Import a different file'" class="link" />
          </div>
        }
      </div>
    }
  }

  @if (status() === 'error') {
    <div class="result">
      <tidy-image [src]="'assets/svg/close-circle-outline.svg'" class="result-icon" />
      <tidy-text
        [title]="errorPhase() === 'apply' ? 'Couldn’t save projections' : 'Couldn’t read this PDF'"
        class="result-title" />
      <tidy-error-message [text]="errorMessage()" />

      @if (errorPhase() === 'apply') {
        <tidy-button
          [text]="'Try again'"
          [action]="applyAction"
          class="primary" />
      } @else {
        <tidy-button
          [text]="'Choose a file'"
          [action]="selectFileAction"
          class="primary" />
      }

      <div class="secondary-link" (click)="close()">
        <tidy-text [actionBody]="'Close'" class="link" />
      </div>
    </div>
  }

</div>
